import React from 'react';
import { withRouter } from 'react-router';
import { HUB_TILES } from '../aciData.js';

export class ACIHub extends React.Component {
    handleTileClick = (link) => {
        this.props.history.push(link);
    };

    render() {
        return (
            <>
                <p className="aci-hub-subtitle">2 modules</p>
                <div className="aci-hub-grid">
                    {HUB_TILES.map((tile) => (
                        <button
                            key={tile.key}
                            type="button"
                            className="aci-hub-tile"
                            onClick={() => this.handleTileClick(tile.link)}
                        >
                            <span className="aci-hub-tile-icon">{tile.icon}</span>
                            <span className="aci-hub-tile-label">{tile.label}</span>
                            {tile.sub && <span className="aci-hub-tile-sub">{tile.sub}</span>}
                        </button>
                    ))}
                </div>
            </>
        );
    }
}

export default withRouter(ACIHub);
